module.exports = __webpack_public_path__ + "static/media/health_policy_H.438ebd22.svg";